module.exports = __webpack_public_path__ + "img/avatar-robot.4a1e905d.png";